const STORAGE_ASSET_URL = /(\s(?:src|href)=["'])(?:(?:https?:)?\/\/(?:api\.tocin\.com\.tw|api\.yimantw\.net))?(\/storage\/(?:app\/)?[^"']+)(["'])/gi

export function apiOrigin (baseUrl = process.env.VUE_APP_BASE_URL || '') {
  const matched = String(baseUrl).match(/^(https?:\/\/[^/]+)/i)
  return matched ? matched[1] : ''
}

export function normalizeContentAssetUrls (html, baseUrl = process.env.VUE_APP_BASE_URL || '') {
  if (!html) return html || ''

  const origin = apiOrigin(baseUrl)
  if (!origin) return html

  return String(html).replace(STORAGE_ASSET_URL, (match, prefix, path, quote) => {
    return `${prefix}${origin}${path}${quote}`
  })
}
